import ModalClose from '@mui/icons-material/CloseRounded';
import MenuIcon from '@mui/icons-material/Menu';
import Box from '@mui/material/Box';
import DialogTitle from '@mui/material/DialogTitle';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Image } from 'primereact/image';
import { InputText } from 'primereact/inputtext';
import { Tag } from 'primereact/tag';
import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import handleErrors from '../../../assets/apiEroor/ErrorHandler';
import { supplyPartnerColumns } from '../../../assets/const/Constant';
import getRequest, { postRequest, useApi } from '../../../assets/helper/ApiHandler';
import DuplicateIcon from '../../../assets/images/icons/duplicate.svg';
import EditIcon from '../../../assets/images/icons/edit.svg';
import ReportIcon from '../../../assets/images/icons/report.svg';
import SampleIcon from '../../../assets/images/icons/sample.svg';
import { ApiData } from '../../../data/apiData';
import BootstrapDateRangePicker from '../../date/BootstrapDateRangePicker';
import ColumnsFilter from '../../filter/ColumnsFilter';
import Filter from '../../filter/Filter';
import PopupContent from '../PopupContent';
import moment from 'moment';
import { Toast } from 'primereact/toast';
import PaginatorTemplate from '../../PanginatorTemplate';
import { useDispatch, useSelector } from 'react-redux';
import { SUPPLY_PARTNER } from '../../../assets/const/reportTypeConst';
import { ActionBttonColumn } from '../../ActionButtonColumn';
import { setFilters } from '../../../redux/reducer/filterslice';
import { cloneDeep } from 'lodash';
import useInitialFilter from '../../../hooks/filterHook';
import { demandRequestsBodyTemplate, erpmBodyTemplate, fillRateBodyTemplate, impressionsBodyTemplate, revenueBodyTemplate, rpmrBodyTemplate } from '../../template/PrefixAndSuffixBody';

export default function ManageSupplyPartner() {
    const filterControlOverlay = useRef(null);
    const [state, setState] = React.useState({ right: false, });
    const [dates, setDates] = useState({
        startDate: useSelector(state => state.dateRange.startDate),
        endDate: useSelector(state => state.dateRange.endDate)
    });
    const [supplyPartnerData, setSupplyPartnerData] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [rowClick, setRowClick] = useState(false);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const initFitr = useSelector(state => state.filters.initialFilters);
    let filters = useSelector(state => state.filters.currentFilters);
    const defaultSelectedColumns = [supplyPartnerColumns[0], supplyPartnerColumns[1], supplyPartnerColumns[2], supplyPartnerColumns[3], supplyPartnerColumns[4], supplyPartnerColumns[5]];
    const [tableColumns, setTableColumns] = useState(defaultSelectedColumns)
    const [visible, setVisible] = useState(false);
    const location = useLocation();
    const supplyPartnerFromReports = location.state ? location.state.supplyPartner : null;
    const [demandAlignmentData, setDemandAlignmentData] = useState([]);
    const [supplyAlignmentData, setSupplyAlignmentData] = useState([]);
    const toast = useRef(null);
    const dispatch = useDispatch();
    const [rows, setRows] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const totalRecords = useSelector(state => state.totalRecords.count);
    const { getUseRequest } = useApi();
    const [isLoading, setIsloading] = useState([]);

    useEffect(() => {
        let _filters = cloneDeep(filters);
        delete _filters.isEnabled;
        delete _filters.isArchived;
        dispatch(setFilters(_filters));
        fetchDemandData();
        fetchSupplyData();
    }, []);

    useEffect(() => {
        fetchData();
    }, [rows, currentPage]);

    useEffect(() => {
        if (location.state && location.state.supplyPartner) {
            filterGlobalValue(supplyPartnerFromReports.supplyPartnerName)
        }
    }, [location.state])


    const filterGlobalValue = (value) => {
        let _filters = cloneDeep(filters);
        _filters.global.value = value;
        dispatch(setFilters(_filters));
        setGlobalFilterValue(value);
    }

    const onGlobalFilterChange = (e) => {
        filterGlobalValue(e.target.value);
    };


    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const applyFiltersOnColumns = (columns) => {
        setTableColumns(columns);
    };

    const navigate = useNavigate();

    const fetchData = async () => {
        setIsloading(true)
        try {
            const url = `/report/supply-partner/main?startDate=${dates.startDate}&endDate=${dates.endDate}&page=${currentPage}&size=${rows}&sort=id,desc`;
            const reportingData = await getUseRequest(url, null, navigate);
            setSupplyPartnerData(reportingData);
        }
        catch (error) {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        } finally {
            setIsloading(false)
        }
    };

    const replaceNullWithZero = (rowData, field) => {
        return rowData[field] === null ? 0 : rowData[field];
    };

    // fetch Supply data 
    const fetchDemandData = async () => {
        try {
            const fetchedDemandAlignmentData = await getRequest('/demands', null, navigate);
            setDemandAlignmentData(fetchedDemandAlignmentData);
        }
        catch (error) {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    };

    const fetchSupplyData = async () => {
        try {
            const fetchedSupplyAlignmentData = await getRequest('/supplies', null, navigate);
            setSupplyAlignmentData(fetchedSupplyAlignmentData);

        } catch (error) {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    };


    const duplicateSupplyPartner = async (data) => {
        let list = [...supplyPartnerData];
        let spData = { ...data };
        try {
            spData.supplyPartnerName = `Duplicate_${spData.supplyPartnerName}`;
            delete spData.id;
            const response = await postRequest('/supply-partners', spData, navigate);
            let res = [response.data, ...list];
            setSupplyPartnerData(res);
        } catch (error) {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    };

    const handleSelectedDate = (dates) => {
        setDates(dates);
    }

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end" style={{ display: 'flex', justifyContent: 'end' }}>
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
                </span>
                {/* <span className="p-input-icon-left">
                    <i className="pi pi-calendar" />
                    <BootstrapDateRangePicker
                        dates={dates}
                        selectedDate={handleSelectedDate}
                    />
                </span> */}
                <span className="p-input-icon-left">
                    <Filter
                        columnsList={supplyPartnerColumns}
                    />
                </span>
                <span className="p-input-icon-left">
                    <ColumnsFilter
                        columnsList={supplyPartnerColumns}
                        tableColumns={tableColumns}
                        index={6}
                        applyColumns={applyFiltersOnColumns}
                    />
                </span>
            </div>
        );
    };

    const header = renderHeader();

    const supplyPartner = (supplyPartnerData) => {
        return (
            <div>
                {['right'].map((anchor) => (
                    <div className="supplyPartner flex justify-content-left" key={anchor} onClick={toggleDrawer(anchor, true)}>
                        {supplyPartnerData.supplyPartnerName}
                    </div>
                ))}
            </div>
        )
    }

    const handleOnRowsChange = (newRows) => {
        setRows(newRows.value);
        setCurrentPage(0);
    };

    const handleOnPageChange = (page) => {
        setCurrentPage(page);
    }

    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="fs-1 white-space-nowrap">Download Samples</span>
        </div>
    );

    const footerContent = (
        <div>
            <Button label="Close" className='button-style-2' onClick={() => setVisible(false)} autoFocus />
        </div>
    );

    const actionBtn = (rowData) => {
        return (
            <ActionBttonColumn
                rowData={rowData}
                type={SUPPLY_PARTNER}
                handleDuplicateRow={duplicateSupplyPartner}
            />
        );
    };

    return (
        <div className="card">
            <Toast ref={toast} position="bottom-right"></Toast>
            <Toolbar className='main-content-header'>
                <Typography variant="h6" noWrap component="div">
                    <h2>Supply Partner</h2>
                </Typography>
                <Link to='/supply-Partner/create'><Button type="button" icon="pi pi-plus" className="button-style-1" label="Add supply partner" size="small"></Button></Link>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    sx={{ mr: 2, display: { sm: 'none' } }}>
                    <MenuIcon />
                </IconButton>
            </Toolbar>
            <DataTable
                value={supplyPartnerData}
                filters={filters}
                loading={isLoading}
                header={header} emptyMessage="No customers found."
                selectionMode={rowClick ? null : 'checkbox'}
                selection={selectedProducts}
                onSelectionChange={(e) => setSelectedProducts(e.value)}
                dataKey="id"
                paginator rows={10}
                paginatorTemplate={
                    PaginatorTemplate({
                        currentPage,
                        totalRecords,
                        rows,
                        handleOnRowsChange,
                        handleOnPageChange,
                    })}
                tableStyle={{ minWidth: '50rem' }} resizableColumns>
                {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column> */}
                {tableColumns.length > 0 ? (
                    tableColumns.map(column => (
                        <Column
                            key={column.key}
                            field={column.field}
                            header={column.name}
                            headerStyle={column.key == 2 || column.key == 1 ? { textAlign: 'left' } : { textAlign: 'right' }}
                            alignHeader={column.key == 2 || column.key == 1 ? "left" : "right"} 
                            bodyStyle={column.key == 1 ? { textAlign: 'left' } : { textAlign: 'right' }}
                            body={(rowData, column) => {
                                switch (column.field) {
                                    case "supplyPartnerName":
                                        return supplyPartner(rowData);
                                    case "erpm":
                                        return erpmBodyTemplate(rowData);
                                    case "rpmr":
                                        return rpmrBodyTemplate(rowData);
                                    case "fillRate":
                                        return fillRateBodyTemplate(rowData);
                                    case "impressions":
                                        return impressionsBodyTemplate(rowData);
                                    case "demandRequests":
                                        return demandRequestsBodyTemplate(rowData);
                                    case "revenue":
                                        return revenueBodyTemplate(rowData);
                                    default:
                                        return replaceNullWithZero(rowData, column.field);
                                }
                            }}
                        />
                    ))
                ) : (
                    <>
                    </>
                )}
                <Column field="action" body={actionBtn} header="Action" headerStyle={{ textAlign: 'center' }} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }}></Column>
            </DataTable>

            <Dialog className='sample-dialog' visible={visible} modal header={headerElement} footer={footerContent} style={{ width: '360px' }} onHide={() => setVisible(false)}>
                <p className="fs-12-500">
                    Your request to download samples is being processed.
                    Once the request is processed, you’ll receive a notification and an email with the link to download the samples.
                </p>
            </Dialog>

            {['right'].map((anchor) => (
                <Drawer key={anchor}
                    anchor={anchor}
                    open={state[anchor]}
                    onClose={toggleDrawer(anchor, false)}>
                    <Box className='drawerHeader'>
                        <DialogTitle >PLX</DialogTitle>
                        <ModalClose className='drawerClose' onClick={toggleDrawer(anchor, false)} />
                    </Box>
                    <PopupContent
                        PerformanceLabel2="Demand Alignment"
                        PerformanceLabel1="Supply Performance"
                        demandAlignment={demandAlignmentData}
                        supplyAlignment={supplyAlignmentData}
                    />
                </Drawer>
            ))}
        </div>
    )

}

